<div class="w-full bg-white border-box radius-10 mb-20" [style.border]="isValidated ? '2px solid #28a745' : 'none'"
  style="border-radius: 10px;" id="contact-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="" width="40px">

          <div>
            <p class="no-margin light-blue bold">4. Invitation à voter au scrutin à blanc</p>
            <p class="no-margin dark-gray text-sm">Cette étape ouvre le scrutin à blanc et envoie aux membres du bureau
              de vote les invitations pour accéder au site de vote et participer à la simulation.</p>
          </div>
        </div>
      </div>
    </div>

  </div>


  <div id="information-grid" class="p-20">
    <v8te-active-button *ngIf="!isTestVoteOpen else testVoteIsOpen"
      [buttonText]="'Ouvrir le scrutin à blanc et envoyer les invitations'" [boxShadow]="'0px 3px 6px #00000008'"
      [primaryColor]="'linear-gradient(90deg, #1990FF 0%, #70BBFD 100%)'"
      [secondaryColor]="'linear-gradient(90deg, #1990FF 0%, #70BBFD 100%)'" [textPrimaryColor]="'#FFFFFF'"
      [textSecondaryColor]="'#FFFFFF'" [iconPosition]="'left'" [border]="'none'"
      [cursor]="isValidated ? 'pointer' : 'not-allowed'" [icon]="'assets/teletransmission-white-icon.svg'"
      [iconAlt]="'send icon'" (click)="isValidated && inviteAssessorsEvent.emit()" [height]="'40px'" [minWidth]="'180px'"
      [active]="isValidated" [width]="'180px'"></v8te-active-button>

    <ng-template #testVoteIsOpen>
      <div class="bg-pale-green radius-10 p-20 flex gap-10 align-items-center" style="border: solid 1px #D2F8DD;">
        <img src="assets/valid-circle-icon.svg" alt="valid icon" width="20px">
        <p class="strong-green no-margin bold">Scrutin à blanc ouvert</p>
      </div>
    </ng-template>

  </div>
</div>